/* eslint-disable @typescript-eslint/naming-convention */
import betstars from './betstars.png';
import casino from './casino.png';
import defaultLogo from './default.png';
import ept from './ept.png';
import foxBet from './fox_bet.png';
import fullTilt from './full_tilt.png';
import millionaire from './millionaire.png';
import poker from './poker.png';
import scoop from './scoop.png';
import starsFirst from './stars_first.png';
import starsRewards from './stars_rewards.png';
import twitch from './twitch.png';
import wcoop from './wcoop.png';

export const legacyChestLogoMap = {
  none: '',
  default: defaultLogo,
  stars_first: starsFirst,
  millionaire,
  casino,
  betstars,
  twitch,
  ept,
  stars_rewards: starsRewards,
  full_tilt: fullTilt,
  scoop,
  wcoop,
  soccer_red: defaultLogo,
  soccer_blue: defaultLogo,
  soccer_brown: defaultLogo,
  soccer_silver: defaultLogo,
  soccer_gold: defaultLogo,
  soccer_platinum: defaultLogo,
  ufc: defaultLogo,
  pirate: defaultLogo,
  pspc: defaultLogo,
  poker,
  fox_bet: foxBet
};
